class MHeader extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      headers: ["header"],
      logos: [".m-logo"],
      topbar: ".m-topbar",
      headerWrapper: ".m-header__wrapper",
      topbarClose: ".m-topbar__close",
    };
    this.domNodes = queryDomNodes(this.selectors, this);
    this.innerWidth = window.innerWidth;
    this.headerOffsetTop = this.domNodes.headerWrapper.offsetTop;
    this.headerHeight = this.domNodes.headerWrapper.offsetHeight;
    this.stickyHeader = this.dataset.sticky;

    this.classes = {
      scrollUp: "scroll-up",
      scrollDown: "scroll-down",
      stuck: "stuck",
      always: "header-sticky-always",
      headerScrollUp: "header-scroll-up",
      headerScrollDown: "header-scroll-down",
    };
    this.init();
  }

  init() {
    this.transparentHeader =
      this.domNodes && this.domNodes.headers[0] && this.domNodes.headers[0].dataset.transparent === "true";
    this.initAddon();
    this.handleSticky();
    this.initDesktopHamburger();
    document.addEventListener("matchMobile", () => this.handleSticky());
    document.addEventListener("unmatchMobile", () => this.handleSticky());
    this.siteNav = new SiteNav(this);
    window.__sfHeader = this;
    window.addEventListener("resize", () => {
      this.innerWidth = window.innerWidth;
    });
  }

  initAddon() {
    this.megamenu = new Megamenu(this);
    if (Shopify.designMode) {
      MinimogTheme = MinimogTheme || {};
      MinimogTheme && MinimogTheme.Wishlist && MinimogTheme.Wishlist.updateWishlistCount();
    }
  }

  /**
   * Wire the desktop hamburger button to open/close the menu drawer directly.
   *
   * We cannot click the mobile hamburger because it lives inside
   * `.m-header__mobile` which is `display:none` on desktop — browsers
   * silently drop clicks on hidden elements.
   *
   * Instead we locate the `.m-menu-drawer` element and toggle it ourselves
   * using the same class/event pattern the rest of the theme uses, then keep
   * the hamburger icon animated in sync via a MutationObserver.
   */
  initDesktopHamburger() {
    const desktopHamburger = this.querySelector(
      ".m-header__desktop .m-menu-button--desktop"
    );
    if (!desktopHamburger) return;

    // The drawer lives inside the mobile header but its height/visibility is
    // controlled by JS — it is NOT hidden by the same media query as the
    // mobile header wrapper, so we can still open it from desktop.
    const drawer = this.querySelector(".m-menu-drawer");
    const desktopHeader = this.querySelector("header.m-header__desktop");
    const mobileHamburgerBox = this.querySelector(
      ".m-header__mobile .m-hamburger-box"
    );

    const openDrawer = () => {
      if (!drawer) return;
      drawer.classList.add("open");
      desktopHamburger.classList.add("active");
      if (mobileHamburgerBox) mobileHamburgerBox.classList.add("active");
      if (desktopHeader) desktopHeader.classList.add("header-drawer-open");
      document.body.style.overflow = "hidden";
    };

    const closeDrawer = () => {
      if (!drawer) return;
      drawer.classList.remove("open");
      desktopHamburger.classList.remove("active");
      if (mobileHamburgerBox) mobileHamburgerBox.classList.remove("active");
      if (desktopHeader) desktopHeader.classList.remove("header-drawer-open");
      document.body.style.overflow = "";
    };

    desktopHamburger.addEventListener("click", () => {
      if (drawer && drawer.classList.contains("open")) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });

    // Close when clicking the drawer backdrop
    if (drawer) {
      const backdrop = drawer.querySelector(".m-menu-drawer__backdrop");
      if (backdrop) {
        backdrop.addEventListener("click", closeDrawer);
      }
    }

    // Close on custom drawerClosed event (fired by SiteNav / other components)
    document.addEventListener("drawerClosed", closeDrawer);

    // Sync desktop icon if SiteNav closes the drawer by toggling the
    // mobile hamburger box class directly (e.g. ESC key, link click).
    if (mobileHamburgerBox) {
      const observer = new MutationObserver(() => {
        if (!mobileHamburgerBox.classList.contains("active")) {
          desktopHamburger.classList.remove("active");
          if (desktopHeader) desktopHeader.classList.remove("header-drawer-open");
        }
      });
      observer.observe(mobileHamburgerBox, {
        attributes: true,
        attributeFilter: ["class"],
      });
    }
  }

  handleSticky() {
    let extraSpace = 20;
    const sectionGroups = document.querySelectorAll(".shopify-section-group-header-group");
    sectionGroups.forEach((section) => {
      if (!section.classList.contains("m-section-header") && !section.classList.contains("m-section-scaling-logo")) {
        extraSpace += section.offsetHeight;
      }
    });
    const topBar = document.querySelector(".m-topbar");
    if (topBar) extraSpace += topBar.offsetHeight;

    let lastScroll = 0;
    window.addEventListener("scroll", () => {
      const currentScroll = window.scrollY;
      if (currentScroll <= extraSpace) {
        this.classList.remove(this.classes.scrollUp, this.classes.stuck, this.classes.always);
        document.body.classList.remove(this.classes.headerScrollUp, this.classes.headerScrollDown);
        return;
      }

      if (this.stickyHeader === "on_scroll_up") {
        this.classList.add(this.classes.stuck);
      } else if (this.stickyHeader === "always") {
        this.classList.add(this.classes.always);
      }

      if (
        currentScroll > this.headerHeight + extraSpace &&
        currentScroll > lastScroll &&
        !this.classList.contains(this.classes.scrollDown)
      ) {
        this.classList.remove(this.classes.scrollUp);
        document.body.classList.remove(this.classes.headerScrollUp);
        this.classList.add(this.classes.scrollDown);
        document.body.classList.add(this.classes.headerScrollDown);
      } else if (currentScroll < lastScroll && this.classList.contains(this.classes.scrollDown)) {
        this.classList.remove(this.classes.scrollDown);
        document.body.classList.remove(this.classes.headerScrollDown);
        this.classList.add(this.classes.scrollUp);
        document.body.classList.add(this.classes.headerScrollUp);
      }
      lastScroll = currentScroll;
    });
  }
}
customElements.define("m-header", MHeader);
